export default "__VITE_ASSET__mA_9u0OI__";